export default {
  // 999: {
  //   type: 'info',
  //   text: '编辑中',
  // },
  1: {
    type: 'success',
    text: '审核通过',
  },
  2: {
    type: 'danger',
    text: '审核不通过',
  },
  3: {
    type: 'info',
    text: '审核中',
  },
  // 4: {
  //   type: 'info',
  //   text: '已撤回',
  // },
  // 5: {
  //   type: 'warning',
  //   text: '审核中',
  // },
  // 6: {
  //   type: 'danger',
  //   text: '审核不通过',
  // },
  // 7: {
  //   type: 'success',
  //   text: '审核通过',
  // },
  // 8: {
  //   type: 'success',
  //   text: '已上线',
  // },
  // 9: {
  //   type: 'info',
  //   text: '已下线',
  // },
};
